export const NEW_PARCEL_ID = 'NPI'
export const NEW_OWNER_ID_PREFIX = '#'

export const ALL_OWNERS_RANGE = {
  F: 1,   // full
  OW: 2,  // owners
  OT: 3   // others
}

export const JOIN_OWNER_INDEX = 'joi'
export const JOIN_MAIN_OWNER_NOTE = '[hlavní]'

export const NEW_LINE_SUBS = '•'
// Alt+7 - new line character substitution
// use find Alt+7 replace Ctrl+J in Excel Find/replace dialog
/* or macro:

Sub DadopaOdřádkovat()

    Cells.Replace What:="•", Replacement:="" & Chr(10) & "", LookAt:=xlPart, SearchOrder _
        :=xlByRows, MatchCase:=False, SearchFormat:=False, ReplaceFormat:=False
    Cells.Rows.AutoFit

End Sub

*/



// WEBPACK FOOTER //
// ./src/config/variables.js